function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import fitInRangeAndStep from '../libs/fitInRangeAndStep';
import injectStyles from '../jss';
import styles from './SliderInput.jss';
var SliderInput = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SliderInput, _React$PureComponent);
  function SliderInput() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, SliderInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SliderInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      editing: false,
      intermediateValue: _this.props.value
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputValue", function () {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = _this.props,
        value = _this$props.value,
        valueFormatter = _this$props.valueFormatter;
      var _this$state = _this.state,
        editing = _this$state.editing,
        intermediateValue = _this$state.intermediateValue;
      if (editing) {
        return intermediateValue;
      }
      return valueFormatter && format ? valueFormatter(value) : value;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnKeyPress", function (event) {
      var ENTER_KEY_CODE = 13;
      if (event.keyCode === ENTER_KEY_CODE) {
        var value = _this.props.value;
        _this.setState({
          intermediateValue: value
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (_ref) {
      var monthlyPayment = _ref.target.value;
      var _this$props2 = _this.props,
        defaultValue = _this$props2.defaultValue,
        onChange = _this$props2.onChange,
        max = _this$props2.max,
        min = _this$props2.min,
        step = _this$props2.step;
      var numbersOnly = monthlyPayment.replace(/\D/g, '');
      var roundedInRange = fitInRangeAndStep(parseInt(numbersOnly, 10), {
        defaultValue: defaultValue,
        max: max,
        min: min,
        step: step
      });
      _this.setState({
        intermediateValue: numbersOnly
      });
      onChange(roundedInRange);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      var value = _this.props.value;
      _this.setState({
        editing: true,
        intermediateValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function () {
      var value = _this.props.value;
      _this.setState({
        editing: false,
        intermediateValue: value
      });
    });
    return _this;
  }
  _createClass(SliderInput, [{
    key: "renderInput",
    value: function renderInput() {
      var _classnames;
      var _this$props3 = this.props,
        classes = _this$props3.classes,
        disabled = _this$props3.disabled,
        kind = _this$props3.kind,
        unit = _this$props3.unit,
        unitRtl = _this$props3.unitRtl;
      var className = classnames(classes.input, this.props.className, (_classnames = {}, _defineProperty(_classnames, classes.input__withUnit, unit), _defineProperty(_classnames, classes.input__withUnitLeft, unitRtl), _classnames));
      return React.createElement("div", {
        className: classes.inputWrapper
      }, React.createElement("input", {
        disabled: disabled,
        id: kind,
        key: "select",
        name: "sliderSelect",
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: this.handleOnKeyPress,
        className: className,
        type: "tel",
        value: this.getInputValue()
      }), React.createElement("div", {
        className: classnames(classes.unit, unitRtl && classes.unit__rtl)
      }, unit));
    }
  }, {
    key: "renderValue",
    value: function renderValue() {
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        kind = _this$props4.kind,
        unit = _this$props4.unit,
        unitRtl = _this$props4.unitRtl;
      var unitClassName = classnames(classes.valueUnit, unitRtl && classes.valueUnit__rtl);
      var Unit = React.createElement("div", {
        className: unitClassName
      }, unit);
      return React.createElement("div", {
        className: classes.valueWrapper
      }, unit && unitRtl && Unit, React.createElement("div", {
        id: kind,
        className: classes.value
      }, this.getInputValue(true)), unit && !unitRtl && Unit);
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var text = option.text,
        value = option.value;
      var optionText = text && text || value;
      return React.createElement("option", {
        key: value,
        value: value
      }, optionText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        classes = _this$props5.classes,
        editable = _this$props5.editable,
        kind = _this$props5.kind,
        label = _this$props5.label;
      return React.createElement("div", {
        className: classes.wrapper
      }, React.createElement("label", {
        htmlFor: kind,
        className: classes.label
      }, label), editable ? this.renderInput() : this.renderValue());
    }
  }]);
  return SliderInput;
}(React.PureComponent);
_defineProperty(SliderInput, "styleRoot", 'SliderInput');
_defineProperty(SliderInput, "defaultProps", {
  unitAlign: 'right'
});
export default injectStyles(styles)(SliderInput);